<template>
  <div class="examResult">
    <el-card>
      <el-row :gutter="20">
        <el-col :sm="12" :md="4" :lg="4">
          <el-cascader clearable style="width:100%" v-model="searchForm.courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择所属课程" :options="subjectTreeList" @change="subjectChange(searchForm.courseIds)"></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-select style="width:100%" clearable v-model="searchForm.examSettingId" placeholder="请选择考试期数" @change="sequenceChange()">
            <el-option v-for="item in examSettingList" :key="item.id" :label="'第' + item.sequence + '期'" :value="item.sequence"></el-option>
          </el-select>
        </el-col>
        <!-- <el-col :sm="12" :md="4" :lg="4" v-if="exportTrue == true">
          <el-cascader style="width:100%;" clearable v-model="searchForm.campusId" :show-all-levels="false" :props="CampusProps" placeholder="请选择所属校区" :options="campusHeaderList" @change="searchCampusChange(searchForm.campusId)"></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" v-if="exportTrue == true">
          <el-select placeholder="请选择所属班级" style="width:100%" v-model="searchForm.classInfoId" clearable @change="getExamResultPageList()">
            <el-option v-for="item in classInfoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" v-if="activeName == 'four'">
          <el-select placeholder="请选择老师" style="width:100%" v-model="searchForm.examSettingTeacherId" clearable>
            <el-option v-for="item in agentTeacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col> -->
        <el-col :sm="12" :md="4" :lg="4" v-if="activeName == 'first'||activeName == 'four'">
          <el-input v-model="searchForm.identity" placeholder="请输入准考证号/证件号" @blur="page.pageNumber = 1" prefix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" v-if="activeName == 'first'||activeName == 'four'">
          <el-input v-model="searchForm.name" placeholder="请输入姓名/手机号" @blur="page.pageNumber = 1" prefix-icon="el-icon-search"></el-input>
        </el-col>

        <el-col :sm="12" :md="4" :lg="4" v-if="activeName == 'four'" style="float:right">
          <el-button type="primary" style="float:right" @click="examApprovalPage.examApprovalPageNumber = 1,getSubjectiveExamResultPageList()">查询</el-button>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" style="text-align:right" v-if="activeName == 'first'">
          <el-button type="primary" @click="getExamResultPageList">查询</el-button>
          <!-- <div v-if="exportTrue==true" class="examResult-button" :loading="true" @click="exportExamResultExcel">导出</div> -->
          <el-button v-if="exportTrue==true" :loading="exportLoading" @click="exportExamResultExcel">导出</el-button>
        </el-col>
        <!-- <el-col :sm="12" :md="12" :lg="6" v-if="timeTrue == true">
          <div class="examStudent-text2">距离报名结束：{{examTime}}</div>
        </el-col>-->
      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:20px;">
        <el-tab-pane label="考试成绩" name="first">
          <el-table ref="pageTable" :data="page.rows" @sort-change="changeSort" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="width: 100%;" border>
            <el-table-column show-overflow-tooltip prop="no" label="序号" width="50"></el-table-column>
            <!-- <el-table-column prop="scoreRank" label="排序" :index="examResultIndexMethod" width="50"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="name" label="姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mobile" label="手机号"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="campusName" label="所属校区">
              <template slot-scope="scope">
                <span v-if="scope.row.campusName!=null">{{scope.row.campusName}}</span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="className" label="班级">
              <template slot-scope="scope">
                <span v-if="scope.row.className!=null">{{scope.row.className}}</span>
                <span v-else>无</span>
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip prop="courseName" label="考试课程">
              <template slot-scope="scope">
                <span v-if="scope.row.courseName!=null">{{scope.row.courseName}}</span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="sequence" label="考试期数" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="courseName" sortable label="考试成绩" width="120">
              <template slot-scope="scope">
                <div :class="scope.row.score>=60?'examResult-score1':'examResult-score2'" @click="goExamAchievement(scope.row)">{{scope.row.score||'-'}}</div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="exerciseTime" sortable :sort-orders="['ascending', 'descending']" label="考试时长" width="120">
              <template slot-scope="scope">
                <span>{{scope.row.exerciseTime}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="exerciseTime" sortable :sort-orders="['ascending', 'descending']" label="抓拍记录" width="120">
              <template slot-scope="scope">
                <span style="color:#24D2B5;" class="expandClick" @click="toSeizePic(scope.row)">{{scope.row.record}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="approvalState" sortable :sort-orders="['ascending', 'descending']" label="审核结果" width="120">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.approvalState==1" style="color:#E5B27F;">已审核</span> -->
                <span v-if="scope.row.approvalState==1" style="color:#24D2B5;">已通过</span>
                <span v-if="scope.row.approvalState==2" style="color:#FF5555;">未通过</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="题目解析" name="second">
          <!-- <el-button-group>
            <el-button
              size="small"
              style="min-width:200px;margin-bottom:20px"
              v-for="(item,index) in examList"
              :key="index"
              @click="getQuestionAnalysisByExamId(item.exam.id)"
            >{{item.exam.name}}</el-button>
          </el-button-group>-->
          <div class="row-tab" v-if='examTitleArr.numberExam'>
            <div class="tab">{{examTitleArr.numberExam}}</div>
          </div>
          <el-table ref="multipleTable" :data="questionPage.rows" v-loading="questionLoading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" row-key="id" style="width: 100%;" border>
            <el-table-column type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
            <el-table-column show-overflow-tooltip prop="questionTypeName" label="类型" width="130"></el-table-column>
            <el-table-column show-overflow-tooltip prop="title" label="题干">
              <template slot-scope="scope">
                <div class="message" @click="getInfoById(scope.row.id)">
                  <div class="htmltittle" v-html="scope.row.title"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="answer" label="答案" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.big!=1">{{scope.row.answer||"-"}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="studentCount" label="做题人数" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="correctPercent" label="正确率" sortable width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.big==1">-</span>
                <span v-else>{{scope.row.correctPercent}}%</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="questionPage.total" :page-size="questionPage.pageSize" :current-page="questionPage.pageNumber" @size-change="questionSizeChange" @current-change="questionCurrentChange"></el-pagination>
        </el-tab-pane>
        <el-tab-pane v-if='false' label="数据统计" name="third" :key="activeName">
          <div class="examResult-text3">我的班级</div>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-cascader style="width:100%;margin-top:10px" clearable size="small" v-model="searchSequence.campusId" :show-all-levels="false" :props="CampusProps" placeholder="请选择所属校区" :options="campusHeaderListForSequence" @change="campusIdChangeForSequence()"></el-cascader>
            </el-col>
            <el-col :span="4">
              <el-select size="small" placeholder="请选择所属班级" style="width:100%;margin-top:10px" v-model="searchSequence.classInfoId" clearable @change="dataStatisticsForSequence()">
                <el-option v-for="item in classInfoListForSequence" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <div v-if="key='activeName'&&chartTrue" class="dashboard-show-data" id="myChart"></div>
          <div v-else class="dashboard-show-data2"></div>
          <div class="examResult-text3">对比班级</div>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-cascader style="width:100%;margin-top:10px" clearable size="small" v-model="searchSequences.campusId" :show-all-levels="false" :props="CampusProps" placeholder="请选择所属校区" :options="campusHeaderListForSequence" @change="searchSequences()"></el-cascader>
            </el-col>
            <el-col :span="6">
              <el-select multiple size="small" placeholder="请选择所属班级" style="width:100%;margin-top:10px" v-model="searchSequences.classInfoIds" clearable @change="classInfoIdsChange()">
                <el-option v-for="item in classInfoListForSequences" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" style="line-height:32px;margin-top:10px">一次最多对比三个班级</el-col>
          </el-row>
          <div v-if="key='activeName'&&chartTrue2" class="dashboard-show-data" id="myChart1"></div>
          <div v-else class="dashboard-show-data2"></div>
        </el-tab-pane>
        <el-tab-pane :label="'考试审批（'+ subjectiveExamResultCount + '）'" name="four">
          <!-- <examApproval  :searchForm="searchForm" :showFourBlock="showFourBlock" @showFourBlockChange="showFourBlockChange" v-if="activeName=='four'"></examApproval> -->
          <div>
            <el-table ref="examApprovalPageTable" :data="examApprovalPage.rows" v-loading="examApprovalLoading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="width: 100%;" border>
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column show-overflow-tooltip prop="name" label="姓名"></el-table-column>
              <el-table-column show-overflow-tooltip prop="mobile" label="手机号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="courseName" label="考试课程">
                <template slot-scope="scope">
                  <span v-if="scope.row.courseName!=null">{{scope.row.courseName}}</span>
                  <span v-else>无</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="sequence" label="考试期数" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="examSettingTeacherName" label="审批人" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="sequence" label="操作" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.teacherScore===2" class="operation-style" @click="goExamApproval(scope.row)">查看</span>
                  <span v-if="scope.row.teacherScore===1" class="operation-style" @click="goExamApproval(scope.row)">审批</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="score" label="考试成绩" width="120"></el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="examApprovalPage.total" :examApprovalPage-size="examApprovalPage.examApprovalPageSize" :current-examApprovalPage="examApprovalPage.examApprovalPageNumber" @size-change="examApprovalSizeChange" @current-change="examApprovalCurrentChange"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="查看明细" :visible.sync="viewDetial" width="50%" left>
        <div class="view-content" v-if="viewForm.big==1">
          <div class="view-one">
            <span style="width: 70px;white-space:nowrap">试题题干：</span>
            <span v-html="viewForm.title"></span>
          </div>
        </div>

        <div class="view-content" v-else>
          <div class="view-one">
            <span style="width: 70px;white-space:nowrap">试题题干：</span>
            <span v-html="viewForm.title"></span>
          </div>
          <div class="view-one" v-if="viewForm.mode!='判断'">
            <span style="width: 70px;white-space:nowrap">试题选项：</span>
            <div class="optint-list">
              <div v-for="(item,index) in viewForm.optionList" :key="index">
                <div style="font-size:14px;line-height:30px;">
                  {{item.options}}:&nbsp;&nbsp;
                  <span style="display: inline;" v-html="item.name"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="view-one">
            <span style="width: 70px;white-space:nowrap">试题答案：</span>
            <span v-html="viewForm.answer"></span>
          </div>
          <div class="view-one">
            <span style="width: 70px;white-space:nowrap">试题解析：</span>
            <span v-html="viewForm.analysis"></span>
          </div>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
require("echarts/lib/component/title");
// import examApproval from "./examApproval";
export default {
  components: {
    // examApproval
  },
  data () {
    return {
      examTitleArr: {},
      firstCourseData: [],
      secondCourseData: [],
      showFourBlock: false,
      showExamApproval: false,
      activeName: "first",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
        orderBy: "",
      },
      questionPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      classInfoList: [],
      classInfoListForSequence: [],
      classInfoListForSequences: [],
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        courseIds: [],
        identity: '',
        examSettingId: "",
        name: "",
        classInfoId: "",
        examSettingTeacherId: null,
        campusId: [],
      },
      campusHeaderList: [],
      campusHeaderListForSequence: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      examId: "",
      subjectiveExamResultCount: 0,
      countSearchForm: {},
      examSearchForm: {},
      searchQuestion: {},
      sequenceList: [],
      avgScoreList: [],
      passPercentList: [],
      sequenceLists: [],
      avgScoreLists: [],
      passPercentLists: [],
      agentTeacherList: [],
      myChartTitle: "",
      myChartTitles: "",
      searchSequence: {
        campusId: "",
        classInfoId: "",
      },
      searchSequences: {
        campusId: "",
        classInfoIds: [],
      },
      exportLoading: false,
      formLabelWidth: "80px",
      examSettingList: [],
      examList: [],
      viewForm: [],
      exportTrue: true,
      chartTrue: false,
      chartTrue2: false,
      loading: false,
      questionLoading: false,
      viewDetial: false,
      examApprovalLoading: true,
      examApprovalPage: {
        rows: [],
        total: 0,
        examApprovalPageSize: 10,
        examApprovalPageNumber: 1,
        sortName: "",
        sortOrder: "",
        orderBy: "",
      },
      examSearchForm: {},
    };
  },
  activated () {
    if (this.activeName == 'four') {
      this.getSubjectiveExamResultPageList();
    }
  },
  watch: {},
  mounted () {
    // this.getHeaderCampusList();
    this.activeName = this.$route.query.activeName == '4' ? 'four' : 'first'
    this.getSubjectCourseExamCount(this.$route.query.activeName == '4' ? "getAuditList" : "getResultList");
    // this.getSubjectiveExamResultCount();
  },
  methods: {
    toSeizePic (row) {
      this.$router.push({
        path: "/candidPhotograph",
        query: {
          courseName: row.courseName,
          studentId: row.studentId,
          subjectName: row.subjectName,
          examinationSettingId: row.examinationSettingId,
          examinationSettingItemId: row.examinationSettingItemId,
          examinationStudentInfoId: row.examinationStudentInfoId,
        },
      })
    },
    examResultIndexMethod (index) {
      console.log(index, index + 1 + (this.page.pageNumber - 1) * 10)
    },
    examIndexMethod (index) {
      console.log(index, index + 1 + (this.page.pageNumber - 1) * 10)
      // return index + 1 + (this.page.pageNumber - 1) * 10;
    },
    indexMethod (index) {
      return index + 1 + (this.questionPage.pageNumber - 1) * 10;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.getExamResultPageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getExamResultPageList();
    },
    questionSizeChange (pageSize) {
      this.questionPage.pageSize = pageSize;
      this.getQuestionAnalysisByExamId();
    },
    questionCurrentChange (pageNumber) {
      this.questionPage.pageNumber = pageNumber;
      this.getQuestionAnalysisByExamId();
    },
    getHeaderCampusList () {
      this.api.campus.getCampusTree({ parentId: 1 }).then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  if (itemss.children.length != 0) {
                    delete itemss.children;
                  } else {
                    delete itemss.children;
                  }
                }
              } else {
                delete items.children;
              }
            }
          } else {
            delete item.children;
          }
        }
        this.campusHeaderList = result.data;
        // this.searchForm.campusId = this.campusHeaderList[0].children[0].children[0].id;
        // this.getSubjectCourseExamCount();
        this.api.classInfo.getClassInfoList().then((resu) => {
          if (resu.success) {
            this.classInfoList = resu.data;
            // this.searchForm.classInfoId = this.classInfoList[0].id;
          } else {
            this.$message.error(resu.message);
          }
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    searchCampusChange (item) {
      if (typeof item == "object") {
        this.getClassInfoList(item);
        this.searchForm.classInfoId = "";
        this.getExamResultPageList();
      }
    },
    getClassInfoList (id) {
      this.api.classInfo.getClassInfoList().then((result) => {
        if (result.success) {
          this.classInfoList = result.data;
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    getSubjectiveExamResultCount () {
      this.examSearchForm.sequence = this.searchForm.examSettingId;
      this.examSearchForm.courseId = typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2]
      this.examSearchForm.subjectId = typeof this.searchForm.courseIds == 'string' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds[1]
      this.api.examStudent.getSystemResultCount(this.examSearchForm).then((result) => {
        if (result.success) {
          this.countSearchForm = {};
          this.subjectiveExamResultCount = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    showFourBlockChange (val) {
      this.showFourBlock = val;
    },
    getAgentTeacherList (id) {
      this.api.agentUserInfo.getAgentTeacherList().then((result) => {
        if (result.success) {
          this.agentTeacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    getSubjectCourseExamCount (action) {
      this.api.examSetting.getSubjectCourseExamCount().then((result) => {
        if (result.success) {
          this.subjectTreeList = result.data
          this.searchForm.courseIds = result.data[0].children[0].children[0].id;
          if (this.activeName == 'first') {
            this.setInitFirstSelectOps(action)
          } else {
            this.setSecondSelectOps(action)
          }
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    handleClick (tab, event) {
      // console.log(tab)
      // if (tab.name == "first") {
      //   this.getSubjectCourseExamCount("getResultList")
      //   this.exportTrue = true;
      // }
      // if (tab.name == "second") {
      //   this.getSubjectCourseExamCount("getRelationList")
      //   this.exportTrue = false;
      // }
      // if (tab.name == "third") {
      //   this.exportTrue = false;
      // }
      // if (tab.name == "four") {
      //   this.getSubjectCourseExamCount("getAuditList")
      // }
      if (tab.name == "first") {
        this.getExamResultPageList();
        this.exportTrue = true;
      }
      if (tab.name == "second") {
        this.getQuestionAnalysisByExamId()
        this.exportTrue = false;
      }
      if (tab.name == "third") {
        this.getHeaderCampusListForSequence();
        // this.drawLine1();
        this.exportTrue = false;
      }
      if (tab.name == "four") {
        this.getSubjectiveExamResultCount();
        this.getSubjectiveExamResultPageList();
        this.getAgentTeacherList();
      }
    },
    setInitFirstSelectOps (type) {
      this.api.examSetting.getExamSequenceList({ subjectId: type == 'getResultList' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds }).then((result) => {
        if (result.success) {
          this.examSettingList = result.data;
          this.searchForm.examSettingId = this.examSettingList[0] ? this.examSettingList[0].sequence : '';
          if (this.$route.query.activeName == 4) {
            this.activeName = "four";
          } else {
            this.getExamResultPageList();
          }
          if (type == 'getResultList') this.getExamResultPageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    setSecondSelectOps (type) {
      this.api.examSetting.getExamSequenceList({ subjectId: type == 'getRelationList' || type == 'getAuditList' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds }).then((result) => {
        if (result.success) {
          this.examSettingList = result.data;
          this.searchForm.examSettingId = this.examSettingList[0] ? this.examSettingList[0].sequence : '';
          this.searchForm.sequence = this.examSettingList[0] ? this.examSettingList[0].sequence : '';
          if (this.$route.query.activeName == 4) {
            this.activeName = "four";
          } else {
            this.getExamResultPageList();
          }
          if (type == 'getRelationList') {
            this.getQuestionAnalysisByExamId()
          }
          if (type == 'getAuditList') {
            this.getSubjectiveExamResultCount();
            this.getSubjectiveExamResultPageList();
            this.getAgentTeacherList();
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    subjectChange (item) {
      if (typeof item == "object") {
        if (this.activeName == "first") {
          this.page.pageNumber = 1;
          this.searchForm.courseIds = item[2]
          this.searchForm.examSettingId = "";
          this.getExamSettingList(item[1]);
        } else {
          this.questionPage.pageNumber = 1;
          this.getExamSettingList(item[1]);
          this.searchForm.examSettingId = "";
          this.questionPage.rows = [];
          this.examSettingList = [];
        }
      }
    },
    getExamSettingList (subjectId) {
      var params = { "subjectId": subjectId }
      this.api.examSetting.getExamSequenceList(params).then((result) => {
        if (result.success) {
          this.examSettingList = result.data;
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    sequenceChange () {
      if (this.activeName == "first") {
        console.log(typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2])
        this.page.pageNumber = 1;
        this.getExamResultPageList();
      }
      if (this.activeName == "second") {
        this.questionPage.pageNumber = 1;
        this.getQuestionAnalysisByExamId();
      }
      if (this.activeName == 'four') {
        this.getSubjectiveExamResultPageList()
        this.getSubjectiveExamResultCount();
      }
    },

    getInfoById (id) {
      this.api.question.getInfoById({ id: id }).then((result) => {
        if (result.success) {
          this.viewForm = result.data;
          this.viewDetial = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    changeSort (val) {
      if (this.$refs.pageTable) {
        this.$refs.pageTable.clearSort();
      }
      if (val.prop == "examResultMap.examScore") {
        if (val.order == "ascending") {
          this.page.orderBy = "student_exercise.score";
        } else if (val.order == "descending") {
          this.page.orderBy = "";
        } else {
          this.page.orderBy = "student_exercise.score";
        }
      }
      if (val.prop == "exerciseTime") {
        if (val.order == "ascending") {
          this.page.orderBy = "student_exercise.exercise_time";
        } else if (val.order == "descending") {
          this.page.orderBy = "student_exercise.exercise_time desc";
        } else {
          this.page.orderBy = "student_exercise.exercise_time";
        }
      }

      this.getExamResultPageList();
    },
    getExamResultPageList () {
      if (!this.searchForm.examSettingId) {
        this.$message.warning('请选择期数！')
        return false
      }
      this.loading = true;
      this.page.rows = [];
      this.examSearchForm.pageSize = this.page.pageSize;
      this.examSearchForm.pageNumber = this.page.pageNumber;
      this.examSearchForm.sortName = this.page.sortName;
      this.examSearchForm.sortOrder = this.page.sortOrder;
      this.examSearchForm.orderBy = this.page.orderBy;
      console.log('filter', typeof this.searchForm.courseIds == 'string', this.searchForm.courseIds, this.subjectTreeList[0].children[0].id)
      this.examSearchForm.courseId = typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2]
      this.examSearchForm.subjectId = typeof this.searchForm.courseIds == 'string' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds[1]
      this.examSearchForm.sequence = this.searchForm.examSettingId
      this.examSearchForm.card = this.searchForm.identity
      this.examSearchForm.nameOrNum = this.searchForm.name;
      this.api.examStudent.getSystemStudentResult(this.examSearchForm).then((result) => {
        this.loading = false;
        this.page.rows = result.data.records;
        for (const i in result.data.records) {
          result.data.records[i].no = (result.data.current - 1) + 1 + Number(i)
        }
        this.page.total = result.data.total;
        this.page.pageNumber = result.data.current;
        this.examSearchForm = {};
      }).catch((error) => {
        console.log(error);
      });
    },
    getExamQuizTitleData () {
      var params = {
        sequence: this.searchForm.examSettingId,
        courseId: typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2],
        subjectId: typeof this.searchForm.courseIds == 'string' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds[1]
      }
      this.api.question.getExamQuizTitleData(params).then((res) => {
        this.examTitleArr = res.data || {};
      }).catch((error) => {
        console.log(error);
      });
    },
    getQuestionAnalysisByExamId (val) {
      if (!this.searchForm.examSettingId) {
        this.$message.warning("请选择期数！")
        return false
      }
      this.questionLoading = true;
      this.questionPage.rows = [];
      this.searchQuestion.pageSize = this.questionPage.pageSize;
      this.searchQuestion.pageNumber = this.questionPage.pageNumber;
      if (val) {
        this.searchQuestion.examId = val;
      } else {
        this.searchQuestion.examId = this.examId;
      }
      this.searchQuestion.sequence = this.searchForm.examSettingId;
      this.searchQuestion.courseId = typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2]
      this.searchQuestion.subjectId = typeof this.searchForm.courseIds == 'string' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds[1]
      this.api.question.getExamQuizData(this.searchQuestion).then((result) => {
        this.questionLoading = false;
        this.questionPage.rows = result.data.records || [];
        this.questionPage.total = result.data.total || 0;
        this.questionPage.pageSize = result.data.size || 10;
        this.questionPage.pageNumber = result.data.current || 1;
        this.getExamQuizTitleData()
      }).catch((error) => {
        console.log(error);
      });
    },

    exportExamResultExcel () {
      this.examSearchForm.pageSize = this.page.pageSize;
      this.examSearchForm.pageNumber = this.page.pageNumber;
      if (this.searchForm.examSettingId != "") {
        this.examSearchForm.examSettingId = this.searchForm.examSettingId;
      }
      if (typeof this.searchForm.courseIds == "object") {
        this.examSearchForm.courseId = this.searchForm.courseIds[1];
      } else {
        this.examSearchForm.courseId = this.searchForm.courseIds;
      }
      if (this.searchForm.name != "") {
        this.examSearchForm.name = this.searchForm.name;
      }

      if (this.searchForm.classInfoId != "") {
        this.examSearchForm.classInfoId = this.searchForm.classInfoId;
      }
      if (this.searchForm.campusId.length > 0) {
        this.examSearchForm.campusId = this.searchForm.campusId[2];
      }
      this.examSearchForm.sortName = this.page.sortName;
      this.examSearchForm.sortOrder = this.page.sortOrder;
      this.$message.warning("正在导出数据，请稍等！");
      this.exportLoading = true;
      this.api.examStudent.exportExamResultExcel(this.examSearchForm).then((result) => {
        if (result.success) {
          this.examSearchForm = {};
          let url = result.data;
          window.open(url);
          this.exportLoading = false;
        } else {
          this.exportLoading = false;
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    examApprovalSizeChange (examApprovalPageSize) {
      this.examApprovalPage.examApprovalPageSize = examApprovalPageSize;
      this.getSubjectiveExamResultPageList();
    },
    examApprovalCurrentChange (examApprovalPageNumber) {
      this.examApprovalPage.examApprovalPageNumber = examApprovalPageNumber;
      this.getSubjectiveExamResultPageList();
    },
    getSubjectiveExamResultPageList () {
      if (!this.searchForm.examSettingId) {
        this.$message.warning('请选择期数！')
        return false
      }
      this.examApprovalLoading = true;
      this.examApprovalPage.rows = [];
      this.examSearchForm.pageSize = this.examApprovalPage.examApprovalPageSize;
      this.examSearchForm.pageNumber = this.examApprovalPage.examApprovalPageNumber;
      this.examSearchForm.sequence = this.searchForm.examSettingId;
      this.examSearchForm.courseId = typeof this.searchForm.courseIds == 'string' ? this.searchForm.courseIds : this.searchForm.courseIds[2]
      this.examSearchForm.subjectId = typeof this.searchForm.courseIds == 'string' ? this.subjectTreeList[0].children[0].id : this.searchForm.courseIds[1]
      this.examSearchForm.card = this.searchForm.identity
      this.examSearchForm.nameOrNum = this.searchForm.name;
      this.api.examStudent.systemAuditData(this.examSearchForm).then((result) => {
        this.examApprovalLoading = false;
        this.examApprovalPage.rows = result.data.records;
        this.examApprovalPage.total = result.data.total;
        this.examSearchForm = {};
        this.showFourBlock = false;
      }).catch((error) => {
        console.log(error);
      });
    },

    goExamApproval (row) {
      this.$router.push({
        path: "/systemAuditPaper",
        query: {
          studentExerciseId: row.studentExerciseId,
          studentInfoId: row.studentInfoId
        },
      });
    },
    getHeaderCampusListForSequence () {
      this.api.campus.getCampusTreegetCampusTree({ parentId: 1 }).then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  if (itemss.children.length != 0) {
                    delete itemss.children;
                  } else {
                    delete itemss.children;
                  }
                }
              } else {
                delete items.children;
              }
            }
          } else {
            delete item.children;
          }
        }
        this.campusHeaderListForSequence = result.data;
        this.campusHeaderListForSequences = result.data;
        this.searchSequence.campusId = this.campusHeaderListForSequence[0].children[0].children[0].id;
        this.searchSequences.campusId = this.campusHeaderListForSequence[0].children[0].children[0].id;
        this.api.classInfo.getClassInfoList({ campusId: this.searchSequence.campusId }).then((resu) => {
          if (resu.success) {
            this.classInfoListForSequence = resu.data;
            this.classInfoListForSequences = resu.data;
            this.searchSequence.classInfoId = this.classInfoListForSequence[0].id;
            if (this.classInfoListForSequences.length > 2) {
              this.searchSequences.classInfoIds = [
                this.classInfoListForSequence[0].id,
                this.classInfoListForSequence[1].id,
                this.classInfoListForSequence[2].id,
              ];
            }
            if (
              this.classInfoListForSequences.length > 1 &&
              this.classInfoListForSequences.length < 3
            ) {
              this.searchSequences.classInfoIds = [
                this.classInfoListForSequence[0].id,
                this.classInfoListForSequence[1].id,
              ];
            }
            if (
              this.classInfoListForSequences.length > 0 &&
              this.classInfoListForSequences.length < 2
            ) {
              this.searchSequences.classInfoIds = [
                this.classInfoListForSequence[0].id,
              ];
            }
            if (this.classInfoListForSequences.length == 0) {
              this.$message.error("该校区暂无班级，请选择正确的校区");
            }
            this.dataStatisticsForSequence();
            this.dataStatisticsForClass();
          } else {
            this.$message.error(resu.message);
          }
        });
      })
        .catch((error) => {
          console.log(error);
        });
    },
    campusIdChangeForSequence () {
      this.searchSequence.classInfoId = "";
      this.api.classInfo.getClassInfoList({ campusId: this.searchSequence.campusId[2] }).then((result) => {
        if (result.success) {
          this.classInfoListForSequence = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    campusIdChangeForSequences () {
      this.searchSequences.classInfoIds = [];
      this.api.classInfo.getClassInfoList({ campusId: this.searchSequences.campusId[2] }).then((result) => {
        if (result.success) {
          this.classInfoListForSequences = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    dataStatisticsForSequence () {
      if (
        this.searchForm.examSettingId == "" ||
        this.searchForm.examSettingId == null
      ) {
        this.$message.error("请选择考试期数");
      } else if (
        this.searchSequence.classInfoId == "" ||
        this.searchSequence.classInfoId == null
      ) {
        this.$message.error("请选择所属班级");
      } else {
        this.searchSequence.courseId = this.searchForm.courseIds[2];
        this.searchSequence.examSettingId = this.searchForm.examSettingId;
        this.api.examResult.dataStatisticsForSequence(this.searchSequence).then((result) => {
          if (result.success) {
            this.sequenceList = [];
            this.avgScoreList = [];
            this.passPercentList = [];
            for (let i in result.data) {
              this.sequenceList[i] = "第" + result.data[i].sequence + "期";
              this.avgScoreList[i] = result.data[i].avgScore;
              this.passPercentList[i] = result.data[i].passPercent;
              this.myChartTitle =
                result.data[0].className +
                result.data[0].subjectCourseName +
                "成绩趋势";
            }
            this.chartTrue = true;
            this.$nextTick(function () {
              this.drawLine();
            });
          } else {
            this.$message.error(result.message);
          }
        });
      }
    },
    classInfoIdsChange () {
      if (this.searchSequences.classInfoIds.length > 3) {
        this.searchSequences.classInfoIds.splice(3, 1);
        this.$message.error("一次最多对比三个班级");
      }
      this.dataStatisticsForClass();
    },
    dataStatisticsForClass () {
      if (
        this.searchForm.examSettingId == "" ||
        this.searchForm.examSettingId == null
      ) {
        this.$message.error("请选择考试期数");
      } else if (
        this.searchSequences.classInfoIds == "" ||
        this.searchSequences.classInfoIds == null
      ) {
        this.$message.error("请选择所属班级");
      } else {
        this.searchSequences.courseId = this.searchForm.courseIds[2];
        this.searchSequences.examSettingId = this.searchForm.examSettingId;
        this.api.examResult.dataStatisticsForClass(this.searchSequences).then((result) => {
          if (result.success) {
            this.sequenceLists = [];
            this.avgScoreLists = [];
            this.passPercentLists = [];
            for (let i in result.data) {
              this.sequenceLists[i] = result.data[i].className;
              this.avgScoreLists[i] = result.data[i].avgScore;
              this.passPercentLists[i] = result.data[i].passPercent;
              this.myChartTitles =
                result.data[0].subjectCourseName + "成绩对比";
            }
            this.chartTrue2 = true;
            this.$nextTick(function () {
              this.drawLine2();
            });
          } else {
            this.$message.error(result.message);
          }
        });
      }
    },
    // drawLine1() {
    //   this.$nextTick(function() {
    //     this.drawLine();
    //     this.drawLine2();
    //   });
    // },

    drawLine () {
      let myChart = echarts.init(document.getElementById("myChart"));
      myChart.setOption(
        {
          title: {
            text: this.myChartTitle,
            x: "center",
            y: "top",
            textAlign: "left",
            fontStyle: "16px",
          },
          tooltip: {},
          legend: {
            x: "center",
            y: "bottom",
            data: ["平均分", "通过率"],
          },
          calculable: true,
          xAxis: {
            data: this.sequenceList,
          },
          yAxis: [
            {
              type: "value",
              name: "平均分",
              splitLine: {
                show: false,
              },
            },
            {
              type: "value",
              name: "通过率%",
            },
          ],
          series: [
            {
              name: "平均分",
              type: "bar",
              barWidth: 60,
              color: ["#4D94FF"],
              data: this.avgScoreList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12,
                    },
                  },
                },
              },
            },
            {
              name: "通过率",
              type: "bar",
              barWidth: 60,
              yAxisIndex: 1,
              color: ["#24D2B5"],
              data: this.passPercentList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12,
                    },
                  },
                },
              },
              axisLabel: {
                textStyle: {
                  color: "#4572A7",
                },
                show: true,
                interval: "auto",
                formatter: "{value}%",
              },
            },
          ],
        },
        true
      );
    },
    drawLine2 () {
      let myChart = echarts.init(document.getElementById("myChart1"));
      myChart.setOption(
        {
          title: {
            text: this.myChartTitles,
            x: "center",
            y: "top",
            textAlign: "left",
            fontStyle: "16px",
          },
          tooltip: {},
          legend: {
            x: "center",
            y: "bottom",
            data: ["平均分", "通过率"],
          },
          calculable: true,
          xAxis: {
            data: this.sequenceLists,
          },
          yAxis: [
            {
              type: "value",
              name: "平均分",
              splitLine: {
                show: false,
              },
            },
            {
              type: "value",
              name: "通过率%",
            },
          ],
          series: [
            {
              name: "平均分",
              type: "bar",
              barWidth: 60,
              color: ["#4D94FF"],
              data: this.avgScoreLists,
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12,
                    },
                  },
                },
              },
            },
            {
              name: "通过率",
              type: "bar",
              barWidth: 60,
              yAxisIndex: 1,
              color: ["#24D2B5"],
              data: this.passPercentLists,
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12,
                    },
                  },
                },
              },
            },
          ],
        },
        true
      );
    },

    goExamAchievement (item) {
      // localStorage.setItem("name", JSON.stringify(name));
      // localStorage.setItem("examAchievement", JSON.stringify(item));
      let obj = {
        studentId: item.studentId,
        studentExerciseId: item.studentExerciseId,
        name: item.name,
      };
      this.$router.push({ path: "/systemExamAchivement", query: obj });
    },
  },

};
</script>
<style scoped>
.examResult-text {
  line-height: 40px;
  font-size: 14px;
}
.examResult-text2 {
  line-height: 40px;
  font-size: 14px;
  color: #4d94ff;
}
.examResult-text3 {
  font-size: 16px;
}
.examResult-addStudent {
  margin-top: 20px;
  text-align: right;
}
.examResult-button {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(77, 148, 255, 1);
  width: 68px;
  height: 38px;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  float: right;
  cursor: pointer;
  color: rgba(77, 148, 255, 1);
  font-size: 14px;
}
.examResult-score1 {
  color: rgb(36, 210, 181);
  font-weight: 600;
  cursor: pointer;
}
.examResult-score2 {
  color: rgb(255, 85, 85);
  font-weight: 600;
  cursor: pointer;
}
.dashboard-show-data {
  height: 400px;
  margin-top: 20px;
}
.dashboard-show-data2 {
  height: 200px;
  margin-top: 20px;
}
</style>
<style lang="less" rel="stylesheet/less">
.examResult {
  p {
    display: inline;
  }
  .addDialog {
    .el-dialog__body {
      padding-top: 10px !important;
    }
  }
  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    p {
      display: inline;
    }
    .optint-list {
      display: flex;
      flex-direction: column;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }
}
.row-tab {
  display: flex;
  flex-direction: row;
}
.row-tab .tab {
  padding: 8px 35px;
  min-width: 100px;
  border: 1px solid #eeeeee;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/systemExamResult.vue